import React from 'react';
import Img from 'gatsby-image';

import StrapiText from '../../text/strapi-markdown-text-snippet';

import { FullWidthContentType } from '../../../models/strapi/full_width_content';

import { colors } from '../../../shared/colors';

import * as styles from '../strapi-full-width-content.module.scss';

interface Props {
    data: FullWidthContentType;
}

const TextUnderneath = ({ data }: Props) => {
    return (
        <div
            style={{
                backgroundColor:
                    data.backgroundColor && data.backgroundColor.backgroundColor
                        ? colors[data.backgroundColor.backgroundColor]
                        : 'transparent'
            }}>
            {data.image && data.image.image ? (
                <div>
                    <Img fluid={data.image.image.childImageSharp.fluid} alt={data.image.alt} />
                </div>
            ) : null}
            {data.text &&
                data.text.text &&
                data.text.text.map((content, i) => (
                    <div className={styles.textContainer} key={i}>
                        <StrapiText data={content} />
                    </div>
                ))}
        </div>
    );
};

export default TextUnderneath;
